import useAPI from '@/hooks/useAPI';
import ProgramRepository from '@/repositories/ProgramRepository';
import { QueryParams } from '@/types/query';

const usePrograms = (params: QueryParams = {}, enabled = true) => {
  const programRepository = ProgramRepository();

  return useAPI({
    queryKey: ['getPrograms', params],
    queryFn: async () => {
      return await programRepository.getPrograms(params);
    },
    enabled
  });
};

export default usePrograms;
